import React from 'react';
function BMIChildrenTable({classification})  {
  return (
    <table >
      <thead>
        <tr>
          <th >النطاق المئوي</th>
          <th >فئة حالة الوزن</th>
        </tr>
      </thead>
      <tbody>
        <tr className={classification === 'Underweight' ? 'highlightedWarning' : ''}>
          <td>أقل من 5%</td>
          <td>وزن غير كافٍ (Underweight)</td>
        </tr>
        <tr className={classification === 'Healthy weight' ? 'highlightedOk' : ''}>
          <td>من 5% حتى 85%</td>
          <td>وزن صحي (Healthy weight)</td>
        </tr>
        <tr className={classification === 'At risk of overweight' ? 'highlightedWarning' : ''}>
          <td>من 85% حتى 95%</td>
          <td> معرض لخطر زيادة الوزن (At risk of overweight)</td>
        </tr>
        <tr className={classification === 'Overweight' ? 'highlightedDanger' : ''}>
          <td>أكبر أو يساوي 95%</td>
          <td>وزن زائد (Overweight)</td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>المصدر:</b>{' '} <br/>
            <a href="https://www.cdc.gov/bmi/faq/">
            مراكز السيطرة على الأمراض والوقاية منها - وكالة الصحة العامة الوطنية في الولايات المتحدة
            </a>
          </td>
        </tr>
        <tr>
          <td colSpan="2">
            <b>تاريخ أخر مراجعة:</b> 28/02/2026
          </td>
        </tr>
      </tbody>
    </table>
  );
}
export default BMIChildrenTable;
